module.exports = __webpack_public_path__ + "img/udmark-light.956c74c3.png";